import { postAPI , getAPI } from "../../api/api";
import { REACT_APP_JOB  } from "../../utils/common";


export async function updateCrowdSourcingStatus(data: any){
    const Details = postAPI( REACT_APP_JOB  + `/updateCrowdSourcingStatusForJob`, data)
    return Details
}


